import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: 'ng-template[appTabContent]',
    standalone: false
})
export class TabContentDirective {
    public constructor(public templateRef: TemplateRef<unknown>) {}
}
